var productMarkup = `
{{#products}}
<div id="product-generic-item">
    <div class="cart-item item-id-element" id="#item-id#">
        <div class="row">

            <div class="col-9 col-sm-9 col-md-7 col-lg-6 order-0 order-sm-0"
                 style="padding-right: 0;">

                <div class="cart-item-image" style="background-image: url('{{iu}}')">
                </div>

                <div class="cart-item-content">

                    <div class="cart-item-name">

                        {{dt}}

                        <p>{{varianTitle}}</p>

                    </div>

                    <div class="cart-item-description">
                       
                    </div>
                    
                    

                    <div class="cart-item-price d-none d-sm-block d-lg-none">
                        <span>Precio:</span>
                        <span class="cart-item-amount">
                            {{cu}}{{pr}}
                        </span>
                    </div>

                </div>
            </div>

            <div class="col-3 order-3 order-sm-2 d-sm-none"></div>

            <div class="col-lg-2 d-none d-lg-block order-lg-1">
                <div class="cart-item-price text-lg-center">
                                                <span class="cart-item-amount">
                                                    {{cu}}{{pr}}
                                                </span>
                </div>
            </div>

            <div class="col-6 col-sm-3 col-md-3 col-lg-4 order-4 order-sm-3 order-lg-2">

                <div class="cart-item-form-container text-sm-center text-md-right">

                    <div class="cart-item-button-deleted text-sm-center">
             
                        
                        <a href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="add-to-cart btn-cart-item-deleted btn-add-to-cart">
                            {{#isInCart}}En carrito{{/isInCart}}
                            {{^isInCart}}Agregar a carrito{{/isInCart}}
                        </a>
                    </div>
                    
                    <br>

                    <div class="cart-item-button-deleted text-sm-center">
                        <span class="btn-cart-item-deleted" onclick="removeFromWishList(this, {{epi}}, {{empi}}, '{{du}}')">
                            Eliminar
                        </span>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
{{/products}}`;


function getVariantInfo(variants) {
    try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []), variantinfo;
        if (variantKeys.length > 0) {
            variantinfo = variantKeys[0];
            if (variantinfo == "Default Title") {
                variantinfo = "";
            }
        } else {
            variantinfo = "";
        }
        return variantinfo;
    } catch (err) {
        return variants;
    }
}

function swymCallbackFn() {
    // gets called once Swym is ready
    var wishlistContentsContainer = document.getElementById("products-rows");
    _swat.fetchWrtEventTypeET(
        function (products) {
            console.log(products);
            // Get wishlist items
            var formattedWishlistedProducts = products.map(function (p) {
                p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
                p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
                p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
                p.varianTitle = p.vi;
                return p;
            });

            var productCardsMarkup = SwymUtils.renderTemplateString(productMarkup, {products: formattedWishlistedProducts});
            wishlistContentsContainer.innerHTML = productCardsMarkup;

            attachClickListeners();

        },
        window._swat.EventTypes.addToWishList
    );
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);


function onAddToCartClick(e) {
    e.preventDefault();
    var productId = e.target.getAttribute("data-product-id");
    var variantId = e.target.getAttribute("data-variant-id");
    alert(variantId);
    var du = e.target.getAttribute("data-url");
    e.target.innerHTML = "Agregando..";
    window._swat.replayAddToCart(
        {empi: productId, du: du},
        variantId,
        function () {
            e.target.innerHTML = "En el carrito";
            window.location.reload();
            console.log("Successfully added product to cart.");
        },
        function (e) {
            console.log(e);
        }
    );
}


function attachClickListeners() {
    var addToCartButtons = document.getElementsByClassName("add-to-cart");

    for (var i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
    }
}

function removeFromWishList($this, epi, empi, du) {
    window._swat.removeFromWishList(
        {epi:epi, empi: empi, du: du},
        function (r) {
            console.log(r)
            $this.parentElement.parentElement.parentElement.parentElement.remove();
            console.log("Remove to wishlist");
        },
    );
}
